import { UserOutlined } from '@ant-design/icons'
import { Button, Form, Input, Typography } from 'antd'
import { type FC } from 'react'
import { useMutation } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { apiForgotPassword } from '~/api/adminApi'
import RadupIcon from '~/assets/images/icon.png'
import { showErrors } from '~/utils/helpers'
import FormCard from './FormCard'
import './styles.scss'

const { Title } = Typography

const ForgotPasswordForm = () => {
  const forgotPasswordMutation = useMutation({
    mutationFn: apiForgotPassword,
    onError: showErrors
  })

  if (forgotPasswordMutation.isSuccess) {
    return <div>
      <Title level={2}>Request Send</Title>
      <p>Check your email for {'<RadUp Password Reset>'} </p>
      <p>If not received, kindly check your spam folder</p>
    </div>
  }

  return <Form
    name="normal_login"
    className="login-form"
    onFinish={forgotPasswordMutation.mutate}
  >
    <Title level={2}>Reset Password</Title>
    <Form.Item
      name="email"
      rules={[
        { required: true, message: 'Please input your email!' }
      ]}
    >
      <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Email" />
    </Form.Item>
    <Form.Item>
      <Button type="primary" htmlType="submit" className="login-form-button" loading={forgotPasswordMutation.isPending}>
        Confirm
      </Button>
    </Form.Item>
  </Form>
}

const ForgotPassword: FC = () => {
  return (
    <div className="signin-form">
      <img src={RadupIcon} width="120" alt="" />
      <FormCard>
        <ForgotPasswordForm />
        <Link style={{ position: 'absolute', bottom: 20 }} to='/signin'>Back to Sign In</Link>
      </FormCard>
    </div>
  )
}

export default ForgotPassword
